/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { Autocomplete, Box, FormHelperText, TextField, useTheme } from "@mui/material";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import Loader from "../../../components/Loader";
import FileUpload from "../../../components/FileUpload";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeByVehicleType, carModels, searchDestination } from "../../../actions/formAction";
import PropTypes from "prop-types";
import DynamicDropDownlist from "./DynamicDropDownlist";
import { searchClient } from '../../../actions/formAction';

const NewVehicleInfo = ({ isClient }) => {
  const theme = useTheme();
  const formik = useFormikContext();
  const dispatch = useDispatch();


  const formReducser = useSelector((state) => state.form);


  const [mainData, setMainData] = useState({});
  const [makeList, setMakeList] = useState([]);
  const [carModelsData, setCarModelsData] = useState({});

  useEffect(() => {
    if (formReducser.loading === "succeeded") {
      setMainData(formReducser.data);
    }
  }, [formReducser]);

  const disabled = formik.values.status?.id !== 1 && formik.values.status?.id !== 2;

  useEffect(() => {
    const isLoadingSucceeded =
      formReducser.makeByVehicleType.isLoading === "succeeded";

    if (isLoadingSucceeded) {
      setMakeList(formReducser.makeByVehicleType?.makeList || []);
    }
  }, [formReducser.makeByVehicleType.isLoading]);

  useEffect(() => {
    if (formReducser.carModels.isLoadingCarModels === "succeeded") {
      const updateCarModels = formReducser.carModels?.models?.filter(
        (e) =>
          !e.deleted ||
          (formik.values.model?.deleted && e.id === formik.values.model.id)
      );

      setCarModelsData({
        isLoadingCarModels: formReducser.carModels?.isLoadingCarModels,
        models: updateCarModels,
      });
    }
  }, [formReducser.carModels.isLoadingCarModels]);

  useEffect(() => {
    if (formik.values.vehicleType !== null) {
      if (formik.values.vehicleType.id) {
        dispatch(makeByVehicleType({ id: formik.values.vehicleType.id }));
      }
    }
  }, [formik.values.vehicleType, dispatch]);

  useEffect(() => {
    const make = formik.values.make;
    if (formik.values.make !== null) {
      if (make.id) {
        dispatch(carModels({ id: make.id }));
      }
    }
  }, [formik.values.make, dispatch]);




  useEffect(() => {
  }, [formik.values]);

  return (
    <>
      <PageHeader title={t("newVehicleInformation")} />
      <Box
        sx={{
          margin: { xs: '24px 0', md: '64px 49px' },
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        <CustomDatePicker
          disabled={true}
          label={t("entryDate")}
          name="entryDate"
          disableFuture={true}
        />

        {formReducser.makeByVehicleType.isLoading === "pending" && <Loader />}
        {!isClient ? (
          <DynamicDropDownlist
            label="Client Name"
            dataName2="company"
            formik={formik}
            fieldName="client"
            disabled={disabled}
            loadingKey="isLoadingClientData"
            dataKey="client"
            fetchAction={searchClient}
            errorKey="client"
          />
        ) : (
          <Box display="flex" flexDirection="column">
            <TextField
              disabled={true}
              label={t("clientName")}
              variant="outlined"
              name="clientName"
              value={formik.values.client.name || ""}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              error={formik.touched.client && Boolean(formik.errors.client)}
            />
            {formik.touched.client && formik.errors.client && (
              <FormHelperText error>{formik.errors.client}</FormHelperText>
            )}
          </Box>

        )}




        <DynamicDropDownlist
          label="destination"
          formik={formik}
          fieldName="destination"
          disabled={disabled}
          loadingKey="isLoadingDestinationData"
          dataKey="destination"
          fetchAction={searchDestination}
          errorKey="destination"
        />







      </Box>
      <Box
        sx={{
          display: 'grid',
          margin: { xs: '24px 0', md: '64px 49px' },
          gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        <Box display="flex" flexDirection="column">
          <Autocomplete
            disabled={disabled}
            value={formik.values.vehicleType || null}
            onChange={(event, newValue) => {
              formik.setFieldValue("vehicleType", newValue);
              formik.setFieldValue("make", null);
            }}
            onBlur={formik.handleBlur}
            options={mainData.vehicleTypeList || []}
            getOptionLabel={(option) =>
              option.deleted ? `${option.name} (Deleted)` : option.name
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("vehicleType")}
                error={formik.touched.vehicleType && Boolean(formik.errors.vehicleType)}
              />
            )}
          />
          {formik.touched.vehicleType && formik.errors.vehicleType && (
            <FormHelperText error>{formik.errors.vehicleType}</FormHelperText>
          )}
        </Box>
        <Autocomplete
          disabled={disabled}
          value={formik.values.make || null}
          onChange={(event, newValue) => {
            formik.setFieldValue("make", newValue);
            formik.setFieldValue("model", null);
          }}
          options={makeList || []}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("make")}
              error={formik.touched.make && Boolean(formik.errors.make)}
            />
          )}
        />
        <Autocomplete
          disabled={
            (carModelsData.models && carModelsData.models.length === 0) ||
            disabled
          }
          value={formik.values.model || null}
          onChange={(event, newValue) => {
            formik.setFieldValue("model", newValue);
          }}
          options={carModelsData.models || []}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("model")}
              error={formik.touched.model && Boolean(formik.errors.model)}
            />
          )}
        />
        <Autocomplete
          disabled={disabled}
          value={formik.values.fuelType || null}
          onChange={(event, newValue) => {
            formik.setFieldValue("fuelType", newValue);
          }}
          options={mainData.fuelTypeList || []}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("fuelType")}
              error={formik.touched.fuelType && Boolean(formik.errors.fuelType)}
            />
          )}
        />
      </Box>
      <Box
        sx={{
          display: 'grid',
          margin: { xs: '24px 0', md: '64px 49px' },
          gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        {formReducser.carModels.isLoadingCarModels === "pending" && <Loader />}
        <Autocomplete
          disabled={disabled}
          value={formik.values.color || null}
          onChange={(event, newValue) => {
            formik.setFieldValue("color", newValue);
          }}
          options={mainData.colorList || []}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("color")}
              error={formik.touched.color && Boolean(formik.errors.color)}
            />
          )}
        />
        <Box display="flex" flexDirection="column">
          <TextField
            disabled={disabled}
            label={t("vin")}
            variant="outlined"
            name="vin"
            value={formik.values.vin}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.vin && Boolean(formik.errors.vin)}
          />
          {formik.touched.vin && formik.errors.vin && (
            <FormHelperText error>{formik.errors.vin}</FormHelperText>
          )}
        </Box>
        <Box display="flex" flexDirection="column">
          <TextField
            disabled={disabled}
            label={t("year")}
            variant="outlined"
            name="year"
            value={formik.values.year}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={formik.touched.year && Boolean(formik.errors.year)}
            inputProps={{
              maxLength: 4,
            }}
          />
          {formik.touched.year && formik.errors.year && (
            <FormHelperText error>{formik.errors.year}</FormHelperText>
          )}
        </Box>
        <Box display="flex" flexDirection="column">
          <TextField
            disabled={disabled}
            value={formik.values.price}
            onChange={formik.handleChange}
            inputProps={{
              type: "number",
              min: "0.00",
              max: "10000000.00",
              step: "0.01",
            }}
            name="price"
            error={formik.touched.price && Boolean(formik.errors.price)}
            label={t("price")}
            variant="outlined"
          />
          {formik.touched.price && formik.errors.price && (
            <FormHelperText error>{formik.errors.price}</FormHelperText>
          )}
        </Box>
      </Box>
      <Box
        sx={{
          margin: { xs: '24px 0', md: '64px 49px' },
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: { xs: 2, md: 4 },
          p: { xs: 2, md: 3 },
        }}
      >
        <FileUpload
          disabled={disabled}
          label={t("purchasePricePDF")}
          formikName="purchasePriceFile"
          uploadName="Purchase"
          accept=".pdf"
        />

        <Box display="flex" flexDirection="column">
          <TextField
            disabled={disabled}
            value={formik.values.weight}
            onChange={formik.handleChange}
            inputProps={{
              type: "number",
              min: "0.00",
              max: "10000000.00",
              step: "0.01",
            }}
            name="weight"
            error={formik.touched.weight && Boolean(formik.errors.weight)}
            label={t("Weight")}
            variant="outlined"
          />
          {formik.touched.weight && formik.errors.weight && (
            <FormHelperText error>{formik.errors.weight}</FormHelperText>
          )}
        </Box>
      </Box>
    </>
  );
};
NewVehicleInfo.propTypes = {
  isClient: PropTypes.bool.isRequired,
};
export default NewVehicleInfo;
